module.exports = __webpack_public_path__ + "img/item_chip.ea283bb9.svg";